import { render, staticRenderFns } from "./EditorAccordion.vue?vue&type=template&id=5b43e96f&"
import script from "./EditorAccordion.vue?vue&type=script&lang=js&"
export * from "./EditorAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports